import React, { useState } from "react";
import useApi from "../api";
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import toastConfig from '../config/Toast';
import TextArea from "./field_types/TextAreaGeneric";

const DocUploadText = ( ) => {
    const [loading, setLoading] = useState(false); // Add loading state
    const navigate = useNavigate();
    const { get, getStream, post, postStream, put, patch, remove } = useApi();

    const handleRawTextUpload = async (text: string) => {
        setLoading(true); // Start loading before upload
        if (!text) {
            toast.error("Please enter some text", toastConfig);
            return;
        }

        try {
            const response = await post("/documents/text", {
                text: text,
            });
            //toast.success("Document uploaded successfully", toastConfig);
            navigate('/documents/' + response.data.id + '?new=true');
        } catch (error) {
            console.error("Error uploading Document:", error);
            toast.error("Error uploading Document", toastConfig);
        } finally {
            setLoading(false); // End loading after upload
        }
    };

    return (
        <div className="p-16 mt-8 grow">
            {loading && (
                <div className="absolute inset-0 z-50 flex justify-center items-center bg-white bg-opacity-50">
                    <div className="w-12 h-12 mt-4 mb-4 rounded-full animate-spin border-y-2 border-solid border-slate-900 border-t-transparent"></div>
                </div>
            )}
            <div>
                <TextArea callBack={handleRawTextUpload} />
            </div>
        </div>
    );
};

export default DocUploadText;
